<template>
    <f7-page ref="self" :page-content="false" class="select-currency-page">
        <f7-navbar>
            <f7-nav-left>
                <a href="#" class="link icon-only" @click="back">
                    <i class="icon-back icon"></i>
                </a>
            </f7-nav-left>
            <f7-nav-title>
                {{ $t("g.settings.selectCurrency.title") }}
            </f7-nav-title>
            <f7-nav-right></f7-nav-right>
        </f7-navbar>
        <f7-page-content>
            <f7-list class="languages list-dividers list-strong list-outline">
                <f7-list-item @change="updateCurrency" radio radio-icon="end" :title="$t('g.settings.selectCurrency.currencies.RUB')" value="RUB"
                    name="currency" :checked="account.currency.name == 'RUB'"></f7-list-item>
                <f7-list-item @change="updateCurrency" radio radio-icon="end" :title="$t('g.settings.selectCurrency.currencies.KZT')"
                    value="KZT" name="currency" :checked="account.currency.name == 'KZT'"></f7-list-item>
                <f7-list-item @change="updateCurrency" radio radio-icon="end" :title="$t('g.settings.selectCurrency.currencies.KGS')" value="KGS"
                    name="currency" :checked="account.currency.name == 'KGS'"></f7-list-item>
                <f7-list-item @change="updateCurrency" radio radio-icon="end" :title="$t('g.settings.selectCurrency.currencies.UZS')" value="UZS"
                    name="currency" :checked="account.currency.name == 'UZS'"></f7-list-item>
            </f7-list>
        </f7-page-content>
    </f7-page>
</template>

<script lang="ts">
import { f7 } from 'framework7-vue';
import { defineComponent } from "@vue/runtime-core";
import ServiceAccount from "@/services/v2/data/service-account/ServiceAccount";
import ModelAccount from "@models/v2/account/ModelAccount";
import {Ref} from "vue";
import {useTranslate} from "@tolgee/vue";

//TODO возможно уже deprecated компонент его вызов закомментирован в SettingsPage
export default defineComponent({
    setup() {
        const { t } = useTranslate();
        const account = ServiceAccount.of().account as Ref<ModelAccount>;

        return {
            t,
            account
        }
    },
    computed: {},
    methods: {
        async updateCurrency(e: any) {
            try {
                f7.preloader.show();
                // console.log(e.target.value);
                // await store.dispatch('patchClientData', { currency: e.target.value });
                // await AppController.getInstance().auth(localStorage.getItem('token'));
                // await store.dispatch('fetchAccount', null);
                // await store.dispatch('fetchPaymentSystems', null);
                // await store.dispatch('fetchCurrencies', null);
                // await store.dispatch('fetchMyPayments', { refresh: true });
                f7.view.main.router.back();
            } catch (e: any) {
                f7.dialog.alert(this.t("g.settings.selectCurrency.alert.first"), this.t("g.settings.selectCurrency.alert.second"));
            } finally {
                f7.preloader.hide();
            }
        },
        back() {
            f7.view.main.router.back();
        },
    }
});
</script>

<style lang="scss">
.select-currency-page {
    .title-wrapper {
        align-items: center;
        margin: 27px 16px 5px;
        display: flex;
        justify-content: flex-start;
        gap: 8px;
        cursor: pointer;

        .title {
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            text-transform: uppercase;
            color: #818E95;
        }
    }
}
</style>
